<template>
  <div class="informe-uso-container">
    <CardPrime class="informe-uso-card">
      <template #title>
        <div class="card-header">
          <h3 class="card-title">Informes de Uso Practicas</h3>
        </div>
      </template>
      <template #content>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div class="form-field">
            <label for="colegio-select" class="block text-sm font-medium text-gray-700">Seleccionar Colegio:</label>
            <ColegioDropdown
              v-model="selectedColegio"
              @change="cargarCursos"
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona un Colegio'"
              :error="errors.colegio"
            />
            <small v-if="mostrarErrores && errors.colegio" class="p-error">{{ errors.colegio }}</small>
          </div>
          <div class="form-field">
            <label for="curso-select" class="block text-sm font-medium text-gray-700">Seleccionar Curso:</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona un Curso'"
              :error="errors.curso"
              :modelValue="selectedCurso"
              @update:modelValue="selectedCurso = $event"
            />
            <small v-if="mostrarErrores && errors.curso" class="p-error">{{ errors.curso }}</small>
          </div>
          <div class="form-field">
            <label for="casa-select" class="block text-sm font-medium text-gray-700">Seleccionar Casa:</label>
            <CursoCasaDropDown
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona una Casa'"
              :error="errors.casa"
              :modelValue="selectedCasa"
              @update:modelValue="selectedCasa = $event"
            />
            <small v-if="mostrarErrores && errors.casa" class="p-error">{{ errors.casa }}</small>
          </div>
          <div class="form-field">
            <label for="inicio" class="block text-sm font-medium text-gray-700">Fecha Inicio:</label>
            <input
              type="date"
              id="inicio"
              v-model="inicio"
              class="p-inputtext w-full border-gray-300 rounded-md shadow-sm"
            />
          </div>
          <div class="form-field">
            <label for="fin" class="block text-sm font-medium text-gray-700">Fecha Fin:</label>
            <input
              type="date"
              id="fin"
              v-model="fin"
              class="p-inputtext w-full border-gray-300 rounded-md shadow-sm"
            />
          </div>
        </div>
        <ButtonPrime label="Generar Informe" @click="generarInformePracticas" class="mb-4" :disabled="loading" />
        <div v-if="resumenPracticas.length > 0" class="mt-4">
          <h4 class="text-lg font-semibold mb-2">Resumen por Asignatura:</h4>
          <DataTable :value="resumenPracticas" class="p-datatable-sm" dataKey="IdAsignatura">
            <ColumnPrime field="NombreAsignatura" header="Asignatura" sortable />
            <ColumnPrime field="Correctas" header="Correctas" sortable />
            <ColumnPrime field="Incorrectas" header="Incorrectas" sortable />
          </DataTable>
        </div>
        <div v-if="informePracticas.length > 0" class="mt-4">
          <h4 class="text-lg font-semibold mb-2">Detalle de Prácticas:</h4>
          <DataTable
            :value="informePracticas"
            :paginator="true"
            :rows="rows"
            :totalRecords="totalRecordsPracticas"
            :lazy="true"
            :loading="loading"
            @page="onPagePracticas"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
            :rowsPerPageOptions="[10, 20, 50, 100, 200, 300, 1000]"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            responsiveLayout="scroll"
            class="p-datatable-sm"
            dataKey="IdPractica"
          >
            <ColumnPrime field="IdPractica" header="ID Práctica" sortable />
            <ColumnPrime field="IdUsuario" header="ID Usuario" sortable />
            <ColumnPrime field="Email" header="Email" sortable />
            <ColumnPrime field="NombreCompleto" header="Nombre Completo" sortable>
              <template #body="slotProps">
                {{ slotProps.data.Nombre }} {{ slotProps.data.ApellidoPaterno }} {{ slotProps.data.ApellidoMaterno }}
              </template>
            </ColumnPrime>
            <ColumnPrime field="NombreCasa" header="Casa" sortable />
            <ColumnPrime field="IdPregunta" header="ID Pregunta" sortable />
            <ColumnPrime field="Pregunta" header="Pregunta" sortable />
            <ColumnPrime field="IdAlternativa" header="ID Alternativa" sortable />
            <ColumnPrime field="Alternativa" header="Alternativa" sortable />
            <ColumnPrime field="EsCorrecta" header="Correcta" sortable>
              <template #body="slotProps">
                {{ slotProps.data.EsCorrecta ? 'Sí' : 'No' }}
              </template>
            </ColumnPrime>
            <ColumnPrime field="IdAsignatura" header="ID Asignatura" sortable />
            <ColumnPrime field="NombreAsignatura" header="Asignatura" sortable />
            <ColumnPrime field="FechaPractica" header="Fecha Práctica" sortable>
              <template #body="slotProps">
                {{ new Date(slotProps.data.FechaPractica).toLocaleString('es-CL') }}
              </template>
            </ColumnPrime>
          </DataTable>
        </div>
        <div
          v-else-if="informePracticas.length === 0 && !loading && wasGeneratedPracticas"
          class="mt-4 p-4 bg-yellow-100 text-yellow-700 rounded"
        >
          No se encontraron datos para los filtros seleccionados.
        </div>
        <ToastPrime />
      </template>
    </CardPrime>
  </div>
</template>
<script>
import usuarioService from '@/services/UsuarioService';
import CardPrime from 'primevue/card';
import ButtonPrime from 'primevue/button';
import DataTable from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import ToastPrime from 'primevue/toast';
import ColegioDropdown from '@/components/selectores/ColegioDropdown.vue';
import SingleCursoCombo from '@/components/selectores/SingleCursoCombo.vue';
import CursoCasaDropDown from '@/components/selectores/CursoCasaDropDown.vue';
export default {
  components: {
    CardPrime,
    ButtonPrime,
    DataTable,
    ColumnPrime,
    ToastPrime,
    ColegioDropdown,
    SingleCursoCombo,
    CursoCasaDropDown
  },
  data() {
    return {
      selectedColegio: '',
      selectedCurso: '',
      selectedCasa: null,
      inicio: '2025-05-01',
      fin: '2025-05-31',
      informeUsoGeneral: [],
      totalRecordsUsoGeneral: 0,
      informeVideos: [],
      resumenVideos: [],
      totalRecordsVideos: 0,
      informePracticas: [],
      resumenPracticas: [],
      totalRecordsPracticas: 0,
      rows: 10,
      currentPageUsoGeneral: 1,
      currentPageVideos: 1,
      currentPagePracticas: 1,
      loading: false,
      wasGeneratedUsoGeneral: false,
      wasGeneratedVideos: false,
      wasGeneratedPracticas: false,
      errors: {
        colegio: '',
        curso: '',
        casa: ''
      },
      mostrarErrores: false
    };
  },
  methods: {
    async cargarCursos() {
      if (!this.selectedColegio) {
        this.cursos = [];
        this.selectedCurso = '';
        this.selectedCasa = null;
        return;
      }
      try {
        const response = await usuarioService.getCursosPorColegio(this.selectedColegio);
        this.cursos = response.data;
        this.selectedCurso = '';
        this.selectedCasa = null;
      } catch (error) {
        console.error('Error al cargar cursos:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar los cursos.',
          life: 3000
        });
      }
    },
    async generarInformeUsoGeneral() {
      this.mostrarErrores = false;
      this.wasGeneratedUsoGeneral = true;
      if (!this.selectedColegio) {
        this.errors.colegio = 'Debes seleccionar un colegio';
        this.mostrarErrores = true;
      }
      if (!this.selectedCurso) {
        this.errors.curso = 'Debes seleccionar un curso';
        this.mostrarErrores = true;
      }
      if (!this.inicio || !this.fin || new Date(this.inicio) > new Date(this.fin)) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Fechas inválidas o incompletas.',
          life: 3000
        });
        return;
      }
      if (this.mostrarErrores) return;
      this.loading = true;
      try {
        const response = await usuarioService.getUsoUsuario(
          this.inicio,
          this.fin,
          this.selectedColegio,
          this.selectedCurso,
          this.currentPageUsoGeneral,
          this.rows
        );
        if (!response || !response.Data || !Array.isArray(response.Data)) {
          throw new Error('Respuesta inválida del servidor: datos no disponibles.');
        }
        this.informeUsoGeneral = response.Data.map(item => ({
          ...item,
          NombreCompleto: `${item.Nombre} ${item.ApellidoPaterno} ${item.ApellidoMaterno}`
        }));
        this.totalRecordsUsoGeneral = response.TotalRecords || this.informeUsoGeneral.length;

        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: response.Mensaje || 'Informe generado con éxito.',
          life: 3000
        });
      } catch (error) {
        console.error('Error al generar informe de uso general:', error);
        this.informeUsoGeneral = [];
        this.totalRecordsUsoGeneral = 0;
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.message || 'No se pudo generar el informe.',
          life: 3000
        });
      } finally {
        this.loading = false;
      }
    },
    async generarInformeVideos() {
      this.mostrarErrores = false;
      this.wasGeneratedVideos = true;
      if (!this.selectedColegio) {
        this.errors.colegio = 'Debes seleccionar un colegio';
        this.mostrarErrores = true;
      }
      if (!this.selectedCurso) {
        this.errors.curso = 'Debes seleccionar un curso';
        this.mostrarErrores = true;
      }
      if (!this.inicio || !this.fin || new Date(this.inicio) > new Date(this.fin)) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Fechas inválidas o incompletas.',
          life: 3000
        });
        return;
      }
      if (this.mostrarErrores) return;
      this.loading = true;
      try {
        const response = await usuarioService.getInformeVisualizacionesVideos(
          this.inicio,
          this.fin,
          this.selectedColegio,
          this.selectedCurso,
          this.currentPageVideos,
          this.rows
        );
        if (!response || !response.Detalle || !Array.isArray(response.Detalle) || !response.Resumen || !Array.isArray(response.Resumen)) {
          throw new Error('Respuesta inválida del servidor: datos no disponibles.');
        }
        this.informeVideos = response.Detalle.map(item => ({
          ...item,
          NombreCompleto: `${item.Nombre} ${item.ApellidoPaterno} ${item.ApellidoMaterno}`
        }));
        this.resumenVideos = response.Resumen;
        this.totalRecordsVideos = response.TotalRecords || this.informeVideos.length;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: response.Mensaje || 'Informe de visualizaciones generado con éxito.',
          life: 3000
        });
      } catch (error) {
        console.error('Error al generar informe de visualizaciones:', error);
        this.informeVideos = [];
        this.resumenVideos = [];
        this.totalRecordsVideos = 0;
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.message || 'No se pudo generar el informe.',
          life: 3000
        });
      } finally {
        this.loading = false;
      }
    },
    async generarInformePracticas() {
      this.mostrarErrores = false;
      this.wasGeneratedPracticas = true;
      if (!this.selectedColegio) {
        this.errors.colegio = 'Debes seleccionar un colegio';
        this.mostrarErrores = true;
      }
      if (!this.selectedCurso) {
        this.errors.curso = 'Debes seleccionar un curso';
        this.mostrarErrores = true;
      }
      if (!this.selectedCasa) {
        this.errors.casa = 'Debes seleccionar una casa';
        this.mostrarErrores = true;
      }
      if (!this.inicio || !this.fin || new Date(this.inicio) > new Date(this.fin)) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Fechas inválidas o incompletas.',
          life: 3000
        });
        return;
      }
      if (this.mostrarErrores) return;
      this.loading = true;

      console.log("this.selectedCursoconsole.log(this.selectedCurso);");
      console.log(this.selectedCurso[0]);

      try {
        const response = await usuarioService.getInformeInteraccionPracticas(
          this.inicio,
          this.fin,
          this.selectedColegio,
          this.selectedCurso[0],
          this.selectedCasa,
          this.currentPagePracticas,
          this.rows
        );
        if (!response || !response.Detalle || !Array.isArray(response.Detalle) || !response.Resumen || !Array.isArray(response.Resumen)) {
          throw new Error('Respuesta inválida del servidor: datos no disponibles.');
        }
        this.informePracticas = response.Detalle.map(item => ({
          ...item,
          NombreCompleto: `${item.Nombre} ${item.ApellidoPaterno} ${item.ApellidoMaterno}`
        }));
        this.resumenPracticas = response.Resumen;
        this.totalRecordsPracticas = response.TotalRecords || this.informePracticas.length;

        //this.resumenPracticas = response.Resumen.filter(r => !this.selectedCasa || r.IdCasa === this.selectedCasa);


        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: response.Mensaje || 'Informe de interacción con prácticas generado con éxito.',
          life: 3000
        });
      } catch (error) {
        console.error('Error al generar informe de prácticas:', error);
        this.informePracticas = [];
        this.resumenPracticas = [];
        this.totalRecordsPracticas = 0;
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.message || 'No se pudo generar el informe.',
          life: 3000
        });
      } finally {
        this.loading = false;
      }
    },
    onPageUsoGeneral(event) {
      this.currentPageUsoGeneral = event.page + 1;
      this.rows = event.rows;
      this.generarInformeUsoGeneral();
    },
    onPageVideos(event) {
      this.currentPageVideos = event.page + 1;
      this.rows = event.rows;
      this.generarInformeVideos();
    },
    onPagePracticas(event) {
      this.currentPagePracticas = event.page + 1;
      this.rows = event.rows;
      this.generarInformePracticas();
    },
    formatTiempo(segundos) {
      if (!segundos) return '00:00:00';
      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const secs = segundos % 60;
      return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
  },
  mounted() {
    // Cargar colegios si ColegioDropdown no lo hace automáticamente
  }
};
</script>
<style scoped>
.informe-uso-container {
  @apply p-4;
}
.informe-uso-card {
  @apply bg-white rounded-lg shadow p-4;
}
.card-header {
  @apply flex justify-between items-center mb-4;
}
.card-title {
  @apply text-xl font-bold text-gray-800;
}
.form-field {
  @apply mb-4;
}
.form-field label {
  @apply block text-sm font-medium text-gray-700 mb-1;
}
.p-inputtext {
  @apply border-gray-300 rounded-md shadow-sm;
}
:deep(.p-datatable-sm) .p-datatable-thead > tr > th,
:deep(.p-datatable-sm) .p-datatable-tbody > tr > td {
  @apply p-2 text-sm;
}
</style>